import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import CustomTable from "../../../../../../common/customTable/CustomTable";
import { UkMrvOldPortStaysColumns } from "../../../../../../constants/CustomTableHeaders";
import axiosHttp from "../../../../../../services/interceptor";
import UKMRVPortStaysNew from "./UKMRVPortStaysNew";
import Loader from "../../../../../../common/Loader/Loader";

const UKMRVPortStays = () => {
	const [ukMrvPortStayData, setUkMrvPortStayData] = useState([]);
	const [loading, setLoading] = useState(false);

	const reportDetails = useSelector(
		(state) => state?.reports?.selectedReportDetails
	);

	const staticColumns = [...UkMrvOldPortStaysColumns];

	const fetchUkMrvPortStaysData = async () => {
		setLoading(true);
		try {
			const ukMrvPortStayData = await axiosHttp({
				url: `api/Report/GetFuelUkMrvPortStays?childReportId=${reportDetails.ReportMstId}`,
				method: "GET",
			});
			if (ukMrvPortStayData?.data?.data) {
				setLoading(false);
				setUkMrvPortStayData(ukMrvPortStayData?.data?.data);
			} else if (ukMrvPortStayData) {
				setLoading(false);
				setUkMrvPortStayData(ukMrvPortStayData?.data);
			} else {
				setUkMrvPortStayData([]);
				setLoading(false);
			}
		} catch (error) {
			setLoading(false);
			console.error(error);
		}
	};

	useEffect(() => {
		fetchUkMrvPortStaysData();
	}, []);

	return (
		<>
			{loading ? (
				<div className="loader">
					<Loader />
				</div>
			) : (
				<>
					{ukMrvPortStayData &&
					ukMrvPortStayData?.reportView === "2.0" ? (
						<UKMRVPortStaysNew
							data={ukMrvPortStayData?.portStayList}
							loading={loading}
						/>
					) : (
						ukMrvPortStayData &&
						ukMrvPortStayData?.length > 0 &&
						ukMrvPortStayData[0]?.reportView === "1.0" && (
							<CustomTable
								columnsData={staticColumns}
								renderTableData={ukMrvPortStayData}
								customProps={{
									isLoading: loading,
									enableSort: false,
									enableToptoolbar: false,
								}}
							/>
						)
					)}
				</>
			)}
		</>
	);
};
export default UKMRVPortStays;
